import React from "react"
import styled from "styled-components"
import { BGWrapper, theme } from "@/common/Mixin"
import NextImg from "../NextImg"

type CustomerCardType = "bottom" | "top"

export interface CustomerCardProps {
  styleType?: CustomerCardType
  style?: React.CSSProperties
  company?: string
  name?: string
  image?: any
  description?: string
  bgImage?: any
}

export default function CustomerCard({
  styleType = "top",
  style,
  company,
  name,
  image,
  description,
  bgImage
}: CustomerCardProps) {
  return (
    <Wrapper style={style} type={styleType}>
      {bgImage && (
        <BGWrapper style={{ zIndex: 0 }}>
          <NextImg
            style={{
              filter: "brightness(0.8)",
              width: "100%",
              height: "100%"
            }}
            src={bgImage}
            alt={company}
          />
        </BGWrapper>
      )}
      <ContentWrapper
        type={styleType}
        style={{
          background:
            "linear-gradient(180deg, rgba(0, 31, 88, 0.00) 0%, #001F58 100%)",
          width: "100%",
          height: "100%",
          zIndex: 1
        }}
      >
        <div style={{ display: "flex" }}>
          {image && (
            <NextImg
              sizes="56px"
              style={{
                objectFit: "scale-down",
                width: "auto",
                height: "100%",
                maxWidth: "44px",
                marginRight: "12px"
              }}
              src={image}
              alt={company}
            />
          )}
          <div style={{ display: "flex", flexDirection: "column" }}>
            {company && <CustomerCompany>{company}</CustomerCompany>}
            {name && <CustomerName className="body2">{name}</CustomerName>}
          </div>
        </div>
        <CustomerDescription className="body">
          {description}
        </CustomerDescription>
      </ContentWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div<{ type: CustomerCardType }>`
  background: ${theme.color.backgroundBlack};
  position: relative;
  display: flex;
  width: 100%;
  height: ${({ type }) => (type === "bottom" ? "100%" : "auto")};
  flex-direction: column;
  justify-content: ${({ type }) =>
    type === "bottom" ? "flex-end" : "flex-start"};
  align-items: center;
`

const ContentWrapper = styled.div<{ type: CustomerCardType }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${({ type }) =>
    type === "bottom"
      ? `
    padding: 0 40px 40px 40px;
    max-height: 40%;
    overflow-x: auto;
    transition: max-height 0.3s ease-in-out;
    &:hover {
      max-height: 100%;
    }
    justify-content: end;
  `
      : `
    padding: 20px;
  `}

  @media (${theme.lg}) {
    width: 100%;
    overflow-x: hidden;
    gap: 12px;
    padding: 40px;
  }
`

const CustomerCompany = styled.h4`
  color: ${theme.color.primary};
`

const CustomerName = styled.div`
  color: ${theme.color.textDisabled};
`

const CustomerDescription = styled.div`
  color: ${theme.color.textContrast};
  padding-top: 12px;
  white-space: pre-line;
  overflow: hidden;
  text-overflow: ellipsis;
`
